import { isValidDate } from '../constants/dates';
import logger from './logger';

// LocalStorageキー
export const STORAGE_KEY = 'fleetpilot_selected_date';

/**
 * 初期日付を取得する
 * 優先順位: VITE_FIXED_DATE > LocalStorage > 今日の日付
 */
export const getInitialDate = (): string => {
  // 1. 環境変数VITE_FIXED_DATEで日付固定（最優先）
  const fixedDate = import.meta.env.VITE_FIXED_DATE;
  if (fixedDate && isValidDate(fixedDate)) {
    return fixedDate;
  }

  // 2. LocalStorageに保存された日付を使用
  try {
    const storedDate = localStorage.getItem(STORAGE_KEY);
    if (storedDate && isValidDate(storedDate)) {
      return storedDate;
    }
  } catch (error) {
    logger.warn('Failed to load date from localStorage:', { error });
  }

  // 3. フォールバック: 今日の日付を返す
  return new Date().toISOString().split('T')[0];
};
